module.exports = __webpack_public_path__ + "img/import-data.e950b5d9.png";